import apiUrl from '../../../constants'
import Vue from 'vue'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import DatePicker from 'vue2-datepicker';

import moment from 'moment'
import JQuery from 'jquery'
let $ = JQuery
import {
  BasicSelect
} from 'vue-search-select'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import commonFunction from '../../../commonFunction'
export default {
  name: 'callpatching',
  components: {
    Loading
  },
  props: [],
  data() {
    return {
      ShippingID: '',
      optNumberType: '1',
      isLoading: false,
      mobileNumber: ''
    }
  },
  created: function () {},
  computed: {},
  mounted() {},
  methods: {

    makecalltest() {
      this.isLoading = true;
      this.input1 = ({
        'customernumber': '9921858997',
        'agentnumber': '9921858997',
        'email': 'abhijeet.patil@xpressbees.com',
        'shippingid': '127607234211',
        'clientid': '2',
        'businessType':'B2B'
      });

      axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'callMePaytm',
          headers: commonFunction.getusertoken(),
          'data': this.input1
        })
        .then(result1 => {
          this.isLoading = false;
          let resultDataCrm = result1.data.data;
          if (resultDataCrm.status) {
            let resultData = result1.data.data.data;
            // console.log(resultData);
            if (resultData.status) {
              this.$alertify.success("Call is in processing", 20);

            } else {
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultData.ReturnMessage;
            this.$alertify.error(msg);
          }
        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        });
    },

    MakeCall() {

      if (this.ShippingID === '') {
        this.$alertify.error('Please enter valid shipping id.');
        return false;
      }
      this.isLoading = true;
      //console.log(this.optNumberType);

      let token = 'c423ed60f34c0021016fc65cb53a9ad4';
      let versionNumber = 'v1';
      this.input = ({
        'ShippingID': this.ShippingID
      })
      axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getTrackShipmentSummeryDetails',
          headers: commonFunction.getusertoken(),
          'data': this.input,
          'headers': {
            'token': token,
            'versionnumber': versionNumber
          }
        })
        .then(result => {

          this.isLoading = false;
          let resultDataCrm = result.data.data;
          if (resultDataCrm.status) {
            let resultData = result.data.data.data;
            //console.log(resultData);
            if (resultData.ReturnCode === 100) {

              var userdetailEncrypt = window.localStorage.getItem('userdetail')
              var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
              var plaintext = bytes.toString(CryptoJS.enc.Utf8);
              var userdetaildata = JSON.parse(plaintext);

              let userMobileNumber = userdetaildata[0].MobileNumber;
              let email = userdetaildata[0].email;

              if (userMobileNumber === '') {
                this.$alertify.error('Agent mobile number not found.');
                return false;
              }

              let resultDataFinal = resultData.ShipmentDetails;
              let prinamryPhone = resultDataFinal.PrinamryPhone;
              let shippingID = resultDataFinal.ShippingID;
              let prinamryNo = prinamryPhone.PhoneNo;

              if (this.optNumberType == '1') {
                if (prinamryNo) {
                  this.mobileNumber = prinamryNo;
                } else {
                  this.$alertify.error('Primary mobile number not found.');
                  return false;
                }
              } else if (this.optNumberType == '2') {
                if (resultDataFinal.SecondaryPhone.PhoneNo) {
                  this.mobileNumber = resultDataFinal.SecondaryPhone.PhoneNo;
                } else {
                  this.$alertify.error('Alternate mobile number not found.');
                  return false;
                }
              } else {
                this.$alertify.error('Please, Select mobile number type.');
                return false;
              }

              this.input1 = ({
                'customernumber': userMobileNumber,
                'agentnumber': this.mobileNumber,
                'email': email,
                'shippingid': shippingID,
                'clientid': '2'
              });

              axios({
                  'method': 'POST',
                  'url': apiUrl.api_url + 'callMePaytm',
                  headers: commonFunction.getusertoken(),
                  'data': this.input1
                })
                .then(result1 => {
                  this.isLoading = false;
                  let resultDataCrm = result1.data.data;
                  if (resultDataCrm.status) {
                    let resultData = result1.data.data.data;

                    if (resultData.status) {
                      this.$alertify.success("Call is in processing", 20);
                    } else {
                      this.$alertify.error(msg);
                    }
                  } else {
                    let msg = resultData.ReturnMessage;
                    this.$alertify.error(msg);
                  }
                }, error => {
                  let msg = error;
                  this.$alertify.error(msg);
                });
            } else {
              let msg = resultData.ReturnMessage;
              this.$alertify.error(msg);
            }
          } else {
            let msg = resultDataCrm.msg.code;
            this.$alertify.error(msg);
          }
        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        });
    },

    ClearData() {
      this.ShippingID = '';
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/callpatching/callpatching.component.js